import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { storage } from './storage';
import http from '@/services/http';
// https://chatgpt.com/c/6a411847-5968-83ed-b78f-b018c29d002f
// import { immer } from 'zustand/middleware/immer';

const initStateData = {
	// user: {
	//   token: "",
	//   id: "",
	//   role: "",
	//   displayName: "",
	//   username: "",
	// },
	user: null,

	subscription: null,

	// cities: undefined,
	// cityLocation: null,
	draftOrders: null,
	activeOrders: null,
	sortDeliveries: 'a-z',
	sortDeliveriesDirection: 'asc',

	orderFieldsToSearch: {},
};

const excludedKeys = ['user', 'subscription', 'activeOrders'];

const useStore = create(
	persist(set => ({
		...initStateData,

		setSubscription: data =>
			set(() => {
				return { subscription: data };
			}),
		login: user =>
			set(state => {
				if (!user) {
					return;
				}

				http.addToken(user.token);

				const lastCityIdUsed = localStorage.getItem('last-city-used');
				// console.log("found: ", lastCityIdUsed);
				if (user?.role === 'master') {
					// The backend sends no cityLocation for masters, so it is resolved here on
					// every login - both branches must set it, not just the restore one.
					const fallbackCity = user.cities?.find(c => c.name === 'Καστοριά') || user.cities?.[0];
					const city =
						(lastCityIdUsed && user.cities?.find(c => c.id == lastCityIdUsed)) || fallbackCity;

					if (city) {
						user.cityLocation = city;
						// Store the id only - storing the city object stringifies to "[object Object]"
						// and never matches again on the next login.
						localStorage.setItem('last-city-used', city.id);
					}
				}

				return {
					user,
				};
			}),

		agreeToTerms: catalog =>
			set(state => {
				return {
					user: { ...state.user, termsAgreed: true },
				};
			}),

		updateCatalog: catalog =>
			set(state => {
				return {
					selectedCity: { ...state.selectedCity, catalog },
				};
			}),

		// logout: () =>
		//   set((state) => {
		//     http.removeToken();
		//     return {
		//       user: { ...userinitStateData },
		//       cities: undefined,
		//       selectedCity: null,
		//       subscription: null,
		//     };
		//   }),

		setUser: value =>
			set(state => {
				return { user: value };
			}),

		setDraftOrders: value =>
			set(state => {
				return { draftOrders: value };
			}),
		setActiveOrders: value =>
			set(state => {
				return { activeOrders: value };
			}),

		setSortDeliveries: value =>
			set(state => {
				return { sortDeliveries: value };
			}),

		setSortDeliveriesDirection: value =>
			set(state => {
				return { sortDeliveriesDirection: value };
			}),

		setOrderFieldsToSearch: value =>
			set(state => {
				return { orderFieldsToSearch: value };
			}),

		removeDraftOrderId: id =>
			set(state => {
				const newOrders = state.draftOrders.filter(it => it.id !== id);
				return {
					draftOrders: newOrders,
				};
			}),

		resetAll: () => {
			set(() => {
				// localStorage.removeItem("last-city-used");

				http.removeToken();

				const newState = {};
				Object.keys(initStateData).forEach(key => {
					newState[key] = initStateData[key];
				});

				return {
					...newState,
				};
			});
		},
		// selectedUser: null,
		// usersLoading: true,
		// usersError: false,
		// theme: {
		//   mode: 'light',  // light | dark
		//   textSize: 'normal',  // small | normal | big
		// },

		// setUsers: (users) => set(_ => {
		//   const newUsers = [...users]
		//   return { users: newUsers }
		// }),

		// setSelectedUser: (usr) => set(_ => {
		//   return { selectedUser: { ...usr } }
		// }),

		// toggleMode: () => set(state => {
		//   return { ...state, theme: { ...state.theme, mode: state.theme.mode === 'light' ? 'dark' : 'light' }}
		// }),

		// setUsersLoading: (value) => set(_ => {
		//   return { usersLoading: value }
		// }),

		// setUsersError: (value) => set(_ => {
		//   return { usersError: value }
		// }),
	})),
	{
		name: 'main',
		// storage: createJSONStorage(() => localStorage),
		storage: createJSONStorage(() => storage),
		// storage: () => AsyncStorage,
		// partialize: state => ({ registrationInfo: state.registrationInfo }),
		partialize: state =>
			Object.fromEntries(
				Object.entries(state).filter(
					// list of keys to NOT persist
					([key]) => !excludedKeys.includes(key),
					// ['registrationInfo']
					// .includes(key),
				),
			),
	},
);

export default useStore;
